import { render, staticRenderFns } from "./HorseRobe.vue?vue&type=template&id=15948aec&"
import script from "./HorseRobe.vue?vue&type=script&lang=js&"
export * from "./HorseRobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports